import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../../helpers/constants";

const ViewCourseModule = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { sModule } = location?.state || {};
  const [currModule, setCurrModule] = useState();
  const videoRef = useRef(null);

  useEffect(() => {
    if (sModule && sModule?.id) {
      setCurrModule(sModule?.module_data[0]);
    } else {
      navigate(routes.courses);
    }
  }, [sModule]);

  const handleStart = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      const playPromise = videoElement.play();
      if (playPromise && typeof playPromise.then === "function") {
        playPromise.catch(() => {});
      }
    }
  };

  const handleEnd = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.pause();
    }
  };

  return (
    <div className="lms-body">
      <div className="lms-content-wrapper lms-content-text">
        <div className="lms-ceontent-course">
          <div className="lms-video-wrapper h-100 w-100">
            <div className="video-box">
              <video
                key={currModule?.url}
                ref={videoRef}
                controls
                preload="metadata"
                width="600"
                src={currModule?.url}
                controlsList="nodownload noremoteplayback"
                disablePictureInPicture
              />
            </div>
            <div className="d-flex align-items-center gap-3 mt-3 justify-content-center">
              <Button
                type="button"
                className="btn-min"
                variant="primary"
                onClick={handleStart}
                disabled={!currModule?.url}
              >
                Start
              </Button>
              <Button
                type="button"
                className="btn-min"
                variant="primary"
                onClick={handleEnd}
                disabled={!currModule?.url}
              >
                End
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCourseModule;
